import React from 'react';
import './FullScreenModalHeader.css';
import Icon from '../../Icon';

export default ({onClick}) => (
  <div
    className="FullScreenModalHeader__Close"
    onClick={onClick}
    role="button"
    aria-label="Exit fullscreen"
    tabIndex="0"
  >
    <Icon icon={Icon.OPTIONS.X} className="FullScreenModalHeader__CloseIcon" />
  </div>
);
